import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import combineEventHandlers from '@bubble-ui/util-combine-event-handlers';
import useIsPressed from '@bubble-ui/hook-use-is-pressed';
import useIsHovered from '@bubble-ui/hook-use-is-hovered';
import useIsKeyboardFocused from '@bubble-ui/hook-use-is-keyboard-focused';
export default function useInteractiveState(props) {
  var _useIsPressed = useIsPressed(props === null || props === void 0 ? void 0 : props.pressed),
      _useIsPressed2 = _slicedToArray(_useIsPressed, 2),
      pressed = _useIsPressed2[0],
      ehPressed = _useIsPressed2[1];

  var _useIsHovered = useIsHovered(props === null || props === void 0 ? void 0 : props.hovered),
      _useIsHovered2 = _slicedToArray(_useIsHovered, 2),
      hovered = _useIsHovered2[0],
      ehHovered = _useIsHovered2[1];

  var _useIsKeyboardFocused = useIsKeyboardFocused(props === null || props === void 0 ? void 0 : props.keyboardFocused),
      _useIsKeyboardFocused2 = _slicedToArray(_useIsKeyboardFocused, 2),
      keyboardFocused = _useIsKeyboardFocused2[0],
      ehKeyboardFocused = _useIsKeyboardFocused2[1];

  var eventHandlers = combineEventHandlers(ehHovered, ehPressed, ehKeyboardFocused, {
    onPressIn: props === null || props === void 0 ? void 0 : props.onPressIn,
    onPressOut: props === null || props === void 0 ? void 0 : props.onPressOut,
    onTouchStart: props === null || props === void 0 ? void 0 : props.onTouchStart,
    onTouchEnd: props === null || props === void 0 ? void 0 : props.onTouchEnd,
    onMouseOver: props === null || props === void 0 ? void 0 : props.onMouseOver,
    onMouseOut: props === null || props === void 0 ? void 0 : props.onMouseOut,
    onMouseDown: props === null || props === void 0 ? void 0 : props.onMouseDown,
    onMouseUp: props === null || props === void 0 ? void 0 : props.onMouseUp,
    onFocus: props === null || props === void 0 ? void 0 : props.onFocus,
    onBlur: props === null || props === void 0 ? void 0 : props.onBlur
  });
  var interactiveState = {
    hovered: hovered,
    pressed: pressed,
    keyboardFocused: keyboardFocused
  };
  return [interactiveState, eventHandlers];
}

function getInteractiveStateCase(interactiveState, disabled) {
  return disabled ? 'disabled' : interactiveState.pressed ? 'pressed' : interactiveState.hovered ? 'hovered' : interactiveState.keyboardFocused ? 'keyboardFocused' : 'default';
}

export function useInteractiveStateCase(props) {
  var _useInteractiveState = useInteractiveState(props),
      _useInteractiveState2 = _slicedToArray(_useInteractiveState, 2),
      interactiveState = _useInteractiveState2[0],
      eventHandlers = _useInteractiveState2[1];

  return [getInteractiveStateCase(interactiveState, props === null || props === void 0 ? void 0 : props.disabled), eventHandlers];
}
export function useInteractiveStateCombined(props) {
  var _useInteractiveState3 = useInteractiveState(props),
      _useInteractiveState4 = _slicedToArray(_useInteractiveState3, 2),
      interactiveState = _useInteractiveState4[0],
      eventHandlers = _useInteractiveState4[1];

  var interactiveStateCombined = _objectSpread(_objectSpread({}, interactiveState), {}, {
    disabled: props === null || props === void 0 ? void 0 : props.disabled,
    interactiveState: getInteractiveStateCase(interactiveState, props === null || props === void 0 ? void 0 : props.disabled)
  });

  return [interactiveStateCombined, eventHandlers];
}
//# sourceMappingURL=index.js.map